import "../App.css";
import { Container, Card } from "react-bootstrap";
import { CiHome, CiAlarmOn, CiApple, CiBandage, CiBezier, CiBookmarkCheck, CiBluetooth, CiCamera } from "react-icons/ci";
import process1 from "../components/assets/meet.jpg";
const MegaMenu = ({ show, onClose }) => {
   const processes = [
    {
      title: "Research & Planning",
      desc: "We start by understanding your business needs, analyzing market trends, and creating a clear roadmap.",
      img: process1
    }
  ];
  const industriesContent = [
    {
      heading: "Finance",
      content: "Streamline banking and investment solutions for better growth.",
      icon: CiHome

    },
    {
      heading: "Healthcare",
      content: "Innovative solutions for hospitals, pharma, and wellness sectors.",
      icon: CiAlarmOn
    },
    {
      heading: "Tech",
      content: "AI, software, IoT, and cloud solutions to boost efficiency.",
      icon: CiApple
    },
    {
      heading: "Manufacturing",
      content: "Automotive, electronics, and industrial solutions optimized.",
      icon: CiBandage
    },
     {
      heading: "Finance",
      content: "Streamline banking and investment solutions for better growth.",
      icon: CiBezier
    },
    {
      heading: "Healthcare",
      content: "Innovative solutions for hospitals, pharma, and wellness sectors.",
      icon: CiBookmarkCheck
    },
    {
      heading: "Tech",
      content: "AI, software, IoT, and cloud solutions to boost efficiency.",
      icon: CiBluetooth
    },
    {
      heading: "Manufacturing",
      content: "Automotive, electronics, and industrial solutions optimized.",
      icon: CiCamera
    },
     {
      heading: "Finance",
      content: "Streamline banking and investment solutions for better growth.",
      icon: CiHome

    }
  ];

  if (!show) return null;

  return (
    <>
    <Container>
      <div className="mega-menu" onMouseLeave={onClose} >
      <h4 className="text-dark m-3">Industries We Serve</h4>
      <p className="text-dark m-3">Working with large datasets requires speed, accuracy, and security—and this platform delivers all three.</p>
      <hr class="gradient-line" />
      <br />
  <Container>
<div className="row">
  <div className="col-9">
    <div className="row">
      {industriesContent.map((item, index) => (
        <div className="col-md-4 mb-2" key={index}>
          <div className="mega-menu-card p-2 mb-2 h-100" style={{ minHeight: "120px" , width: "280px"}}>
            {/* flex container: icon + text */}
            <div className="d-flex align-items-start">
              {/* icon box */}
              <div
                className="align-self-center d-flex justify-content-center align-items-center"
                style={{
                  background: "linear-gradient(145deg, #d4197a, #7c2ae8)",
                  borderRadius: "10px",
                  width: "30px",
                  height: "40px",
                  flex: "0 0 54px",
                }}
              >
                {item.icon && <item.icon size={23} color="#fff" />}
              </div>

              {/* text */}
              <div className="ms-3">
                <h5 className="mega-menu-title mb-1">{item.heading}</h5>
                <p className="mega-menu-description mb-0" style={{fontSize: "15px"}}>{item.content}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>

  <div className="col-3">
     <Card
                className="h-100 border-0 text-dark overflow-hidden rounded-4 shadow"
                style={{
                    background: "linear-gradient(90deg, #F6D5F7 0%, #fff 100%)",
                  boxShadow: "0 6px 20px rgba(0,0,0,0.8)",
                }}
              >
                {/* Image with Number Badge */}
                <div className="position-relative">
                <Card.Img
  variant="top"
  src={processes[0].img}
  alt={processes[0].title}
  style={{ height: "200px", objectFit: "cover" }}
/>


                </div>

                {/* Card Content */}
               <Card.Body className="p-4">
  <Card.Title className="fw-bold text-dark">{processes[0].title}</Card.Title>
  <Card.Text className="text-dark">{processes[0].desc}</Card.Text>
</Card.Body>
              </Card>
  </div>

</div>
</Container> 
    </div>
    </Container>
      </>
  );
};

export default MegaMenu;
